import styled from 'styled-components';
import { getStyles } from '../../utils/getStyles/getStyles';
export const OverlayStyled = styled.div `
  ${props => getStyles(props.styles.container)}
`;
//# sourceMappingURL=overlay.styled.js.map